import { ILEGGELSE_SERVICE_BASE_URL } from "../config.ts";

export const PUT_FORSINKET_MAKULERING_MAL_URL = `${ILEGGELSE_SERVICE_BASE_URL}/forsinket-makulering-mal`;
export const GET_FORSINKET_MAKULERING_MAL_PREVIEW_URL = `${ILEGGELSE_SERVICE_BASE_URL}/forsinket-makulering-mal/preview`;
export const GET_FORSINKET_MAKULERING_MAL_DOCX_URL = `${ILEGGELSE_SERVICE_BASE_URL}/forsinket-makulering-mal/docx`;
